import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export function titleCase({ text }) {
    if (_.isNil(text)) {
        return '';
    }

    return _.join(_.map(_.split(text, ' '), _.upperFirst), ' ');
}
